import { render, staticRenderFns } from "./mySalon.vue?vue&type=template&id=76c37da0&scoped=true&"
import script from "./mySalon.vue?vue&type=script&lang=js&"
export * from "./mySalon.vue?vue&type=script&lang=js&"
import style0 from "./mySalon.vue?vue&type=style&index=0&id=76c37da0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c37da0",
  null
  
)

export default component.exports